import React from 'react';
import './App.css';
import Header from './components/Header';
import MainVisual from './components/MainVisual';
import Challenge from './components/Challenge';
import ApplicationScenarios from './components/ApplicationScenarios';
import SolutionAdvantages from './components/SolutionAdvantages';
import TechArchitecture from './components/TechArchitecture';
import CoreValues from './components/CoreValues';
import DemoVideo from './components/DemoVideo';
import ClientsTestimonials from './components/ClientsTestimonials';
import AboutUs from './components/AboutUs';
import PricingSection from './components/PricingSection';

function App() {
  return (
    <div>
      <Header />
      <MainVisual />
      <Challenge />
      <ApplicationScenarios />
      <SolutionAdvantages />
      <TechArchitecture />
      <PricingSection />
      <CoreValues />
      <DemoVideo />
      <ClientsTestimonials />
      <AboutUs />
      <Footer />
    </div>
  );
}

function Footer() {
  return (
    <footer style={{
      background: '#f8f9fa', color: '#003300', textAlign: 'center', padding: '32px 0 18px 0', marginTop: 48, fontSize: '1.08rem', borderTop: '1.5px solid #e0e0e0', letterSpacing: 1
    }}>
      <div style={{marginBottom: 10}}>
        联系电话：<a href="tel:400-002-8118" style={{color: '#003300', textDecoration: 'underline'}}>400-002-8118</a>
        &nbsp;|&nbsp;
        邮箱：<a href="mailto:develop@livgo.cn" style={{color: '#003300', textDecoration: 'underline'}}>developer@livgo.cn</a>
      </div>
      <div style={{fontSize: '0.98rem', color: '#888', marginTop: 6}}>
        Powered by 千流健康
      </div>
      <div style={{fontSize: '0.9rem', color: '#999', marginTop: 4}}>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style={{color: '#999', textDecoration: 'none'}}>京ICP备2020048349号-3</a>
      </div>
    </footer>
  );
}

export default App;
